<template>
    <div class="d-flex">
        <v-select id="currency" class="text-uppercase currency-select" v-model="select" :items="currencies" item-text="name" item-value="value" hide-details="false" :append-icon="mdiChevronDown" style="max-width: 40%" dense filled flat
                  @change="convertCurrency()">
            <template v-if="select === 'NEAR'" v-slot:prepend-inner>
                <icon-base height="25" width="25" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                    <icon-near iconColor="rgba(0, 0, 0, 1)" />
                </icon-base>
            </template>
            <template v-else v-slot:prepend-inner>
                <v-icon>{{ mdiCurrencyUsd }}</v-icon>
            </template>
        </v-select>
        <v-text-field :rules="rules.price" :id="id" hide-details="auto" outlined class="mx-2" style="max-width: 50%" :label="`Price in ${select}`" hint="" dense v-model="priceConversion[select]"
                      @input="convertCurrency()">
            <template v-if="select === 'NEAR'" v-slot:append>
                <v-icon x-small>{{ mdiCurrencyUsd }}</v-icon>
                <span style="font-size: smaller">{{ priceConversion.USD }}</span>
            </template>
            <template v-else-if="select === 'USD'" v-slot:append>
                <icon-base height="15" width="15" viewBox="0 0 180 225" icon-name="near" class="d-flex align-center">
                    <icon-near iconColor="rgba(0, 0, 0, 1)" />
                </icon-base>
                <span style="font-size: smaller">{{ priceConversion.NEAR }}</span>
            </template>
        </v-text-field>
    </div>
</template>
<style scoped>
</style>
<script>
import IconNear from "../components/IconNear.vue";
import IconBase from "../components/IconBase.vue";
import { mdiChevronDown, mdiCurrencyUsd } from "@mdi/js";

export default {
    name: "BnftPriceInput",
    components: {
        IconBase,
        IconNear,
    },
    props: {
        id: String,
    },
    methods: {
        async convertCurrency() {
            if (this.select === "NEAR" && this.listing) {
                if (isNaN(this.priceConversion.NEAR)) return;
                this.$set(
                    this.priceConversion,
                    "USD",
                    Number.parseFloat(
                        this.priceConversion.NEAR *
                            this.listing.averageUSD
                    ).toFixed(2)
                );
            } else if (this.select === "USD" && this.listing) {
                if (isNaN(this.priceConversion.USD)) return;
                this.$set(
                    this.priceConversion,
                    "NEAR",
                    Number.parseFloat(
                        this.priceConversion.USD *
                            (1 / this.listing.averageUSD)
                    ).toFixed(2)
                );
            }
            this.$emit('input', this.priceConversion.NEAR);
        },
    },
    data: function () {
        return {
            mdiChevronDown,
            mdiCurrencyUsd,
            priceConversion: {
                NEAR: null,
                USD: null,
            },
            listing: null,
            select: "NEAR",
            currencies: [
                { name: "near", value: "NEAR" },
                { name: "usd", value: "USD" },
            ],
            conversions: null,
            rules: {
                price: [
                    (v) => !!v || `Sure?!`,
                    (v) => !isNaN(Number.parseFloat(v)) || "Must be a number.",
                ],
            },
        };
    },
    mounted() {
        const self = this;
        (async function () {
            self.listing = await self.$backend.getLatestNearListing();
        })();
    },
    watch: {
        isLoading() {
            const self = this;
            if (!self.isLoading)
                self.$nextTick(() => {
                    setTimeout(function () {}, 1000);
                });
        },
    },
};
</script>
